import React from 'react';

import { Agent } from '../../../components/Agent';
import { AgentAvatarContainer } from './AgentImageContainer';
import { AgentBuildersLabelContainer } from './AgentBuildersLabelContainer';
import { AgentContactStatusContainer } from './AgentContactStatusContainer';
import { AgentPhoneButtonContainer } from './AgentPhoneButtonContainer';
import { AgentReliableBadgeContainer } from './AgentReliableBadgeContainer';
import { AgentShowMoreOffersContainer } from './AgentShowMoreOffersContainer';
import { AgentTitleContainer } from './AgentTitleContainer';
import { AgentProofsContainer } from './AgentProofsContainer';

import { useOfferContext } from '../../../context';

export function AgentContainer() {
  const { isTop } = useOfferContext();

  return (
    <Agent
      promoted={isTop}
      proofs={<AgentProofsContainer />}
      avatar={<AgentAvatarContainer />}
      badge={<AgentReliableBadgeContainer />}
      title={<AgentTitleContainer />}
      builderLabels={<AgentBuildersLabelContainer />}
      showMoreOffersButton={<AgentShowMoreOffersContainer />}
      phoneButton={<AgentPhoneButtonContainer />}
      contactStatus={<AgentContactStatusContainer />}
    />
  );
}
